import { useState } from "react";
import { ANGEL_NUMBERS } from "@/lib/api";
import Reveal from "@/components/Reveal";

const RINGS = [260, 400, 540, 680, 820];

export default function OrbitSection() {
  const [active, setActive] = useState(1);
  const current = ANGEL_NUMBERS[active];

  return (
    <section data-testid="angel-numbers-section" className="relative overflow-hidden border-y border-white/10 py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0 opacity-[0.04]" style={{ background: "radial-gradient(circle at 50% 50%, #fff 0%, transparent 55%)" }} />
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <p className="font-mono text-[10px] tracking-[0.35em] text-fade">ANGEL NUMBERS / ALIGNMENT</p>
          <h2 className="mt-3 font-display text-4xl font-extrabold uppercase leading-[0.95] tracking-tight text-bone sm:text-6xl">
            The numbers
            <br />
            find you.
          </h2>
        </Reveal>

        <div className="mt-16 hidden items-center justify-center md:flex">
          <div className="relative h-[560px] w-[560px] lg:h-[680px] lg:w-[680px]">
            {RINGS.map((size, i) => {
              const duration = 34 + i * 14;
              const num = ANGEL_NUMBERS[i];
              return (
                <div
                  key={size}
                  className="orbit-ring absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/10"
                  style={{ width: size * 0.72, height: size * 0.72, animationDuration: `${duration}s`, animationDelay: `-${i * 9}s` }}
                >
                  <button
                    data-testid={`orbit-number-${num.n}`}
                    onMouseEnter={() => setActive(i)}
                    onClick={() => setActive(i)}
                    className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2"
                    aria-label={`Angel number ${num.n}`}
                  >
                    <span
                      className={`orbit-ring-rev flex h-14 w-14 items-center justify-center rounded-full border font-display text-lg font-extrabold transition-colors ${
                        active === i ? "border-bone bg-bone text-ink" : "border-white/20 bg-ink text-bone/70 hover:text-bone"
                      }`}
                      style={{ animationDuration: `${duration}s`, animationDelay: `-${i * 9}s` }}
                    >
                      {num.n}
                    </span>
                  </button>
                </div>
              );
            })}
            <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 text-center">
              <p className="font-mono text-[10px] tracking-[0.35em] text-fade">YOU ARE HERE</p>
              <svg className="mx-auto mt-3 h-6 w-6 text-bone/50" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1">
                <circle cx="12" cy="12" r="7" />
                <path d="M12 1v6M12 17v6M1 12h6M17 12h6" />
              </svg>
            </div>
          </div>
        </div>

        <div className="mt-6 flex gap-2 overflow-x-auto pb-2 md:hidden">
          {ANGEL_NUMBERS.map((a, i) => (
            <button
              key={a.n}
              data-testid={`orbit-number-mobile-${a.n}`}
              onClick={() => setActive(i)}
              className={`shrink-0 border px-5 py-3 font-display text-lg font-extrabold transition-colors ${active === i ? "border-bone bg-bone text-ink" : "border-white/20 text-bone/70"}`}
            >
              {a.n}
            </button>
          ))}
        </div>

        <Reveal key={current.n} className="mx-auto mt-10 max-w-xl border border-white/10 bg-coal/60 p-8 backdrop-blur">
          <div data-testid="orbit-meaning-card">
            <div className="flex items-baseline gap-4">
              <span className="font-display text-5xl font-extrabold text-bone">{current.n}</span>
              <span className="font-mono text-xs uppercase tracking-[0.3em] text-fade">{current.title}</span>
            </div>
            <p className="mt-4 text-left text-base font-light leading-relaxed text-neutral-300">{current.desc}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
